import { render } from "./selection_box.vue?vue&type=template&id=1361bd75"
import script from "./selection_box.vue?vue&type=script&lang=js"
export * from "./selection_box.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/selection_box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1361bd75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1361bd75', __exports__)) {
    api.reload('1361bd75', __exports__)
  }
  
  module.hot.accept("./selection_box.vue?vue&type=template&id=1361bd75", () => {
    api.rerender('1361bd75', render)
  })

}


export default __exports__